import { useCallback } from "react"
import { notification } from "components/common"
import { t } from "i18next"
import { mergePaymentsRowPatch } from "../utils/paymentUtils"

export function usePaymentProofUploadHandler({ fullPath, form, ocrEnabled, paymentModesMap, getDataFromImage }) {
  return useCallback(
    data => {
      const rowIndex = fullPath[1]

      if (data == null) {
        mergePaymentsRowPatch(form, rowIndex, {
          paymentProof: null,
          ocrData: null,
          modeOfPayment: null,
          buyerFee: false,
        })
        return
      }

      const attachmentTypeIdForOcr = data?.imageData?.attachmentTypeId ?? data?.attachmentTypeId ?? 1
      const mergedImageData = data?.imageData
        ? {
            ...data.imageData,
            attachmentTypeId: data.imageData?.attachmentTypeId ?? attachmentTypeIdForOcr,
          }
        : data?.imageData

      if (data?.imageData && ocrEnabled) {
        mergePaymentsRowPatch(form, rowIndex, { ocrData: null, buyerFee: false })
        const extraField = paymentModesMap?.[data?.imageData?.paymentModeKey]?.extraFields
        if (extraField?.["bank_deposit_slip"]) {
          notification.info({
            message: `${t("Payment of type")} ${data?.imageData?.paymentMode} ${t(
              "detected. Please upload deposit slip as well."
            )}`,
          })
        }
        getDataFromImage({
          attachmentTypeId: attachmentTypeIdForOcr,
          file: data?.url,
          name: data?.name,
          projectId: data?.projectId,
          detectPaymentMode: false,
        })
          .unwrap()
          .then(parsedData => {
            const isAgency = parsedData?.projectBankAccountMatch?.matchedAccountEntityType === "agency"
            const key = parsedData?.imageData?.paymentModeKey
            mergePaymentsRowPatch(form, rowIndex, {
              ocrData: parsedData,
              buyerFee: isAgency,
              ...(key ? { modeOfPayment: key } : {}),
            })
          })
          .catch(error => notification?.error({ message: error?.message }))
      }

      mergePaymentsRowPatch(form, rowIndex, {
        paymentProof: {
          ...data,
          attachmentTypeId: attachmentTypeIdForOcr,
          imageData: mergedImageData,
        },
        modeOfPayment: data?.imageData?.paymentModeKey || null,
        ...(!ocrEnabled ? { ocrData: null } : {}),
      })
    },
    [fullPath, form, ocrEnabled, paymentModesMap, getDataFromImage]
  )
}
